import { getExecEndpoint } from '../../service/getExecEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';
import { BqResponse } from './types';

export const companyServiceAccountEndpoint = {
  server: defaultServer,
  path: 'company/service-account-email',
  description: 'Get service account email',
};

const endpointGoogleServiceAccountEmailGetExec =
  getExecEndpoint<GoogleServiceAccountEndpointDef>(
    companyServiceAccountEndpoint,
  );
export const endpointGoogleServiceAccountEndpointGET = async () =>
  endpointGoogleServiceAccountEmailGetExec<'GET'>({
    method: 'GET',
  });
export interface GoogleServiceAccountEndpointDef {
  endpoint: typeof companyServiceAccountEndpoint;
  methods: {
    GET: {
      response: GetGoogleServiceAccountResponse;
    };
  };
}

export type GetGoogleServiceAccountResponse = BqResponse<{
  data: GoogleServiceAccountEmail;
}>;

type GoogleServiceAccountEmail = {
  serviceAccountEmail: string;
};
